;; Copyright (C) 2017, Doctor Evidence. All rights reserved.

(ns dre.shared.interface.categories
  "Categories"
  {:authors ["Michiel Borkent" "Joel Kuiper"]}
  (:require
   [dre.coll :refer [index-by]]))

(def categories
  [{:label "Any category"
    :id "all"}
   {:label "PubMed"
    :id "medline"
    :source "medline"}
   {:label "PubMed Central"
    :id "pmc"
    :source "pmc"}
   {:label "Embase"
    :id "embase"
    :source "embase"}
   {:label "Current Contents Connect"
    :id "ccc"
    :source "ccc"}
   {:label "ScienceDirect"
    :id "science-direct"
    :source "science-direct"}
   {:label "NIH Grants"
    :id "nih"
    :source "nih"}
   {:label "Patents"
    :id "patent"
    :source "patent"}
   {:label "ClinicalTrials.gov"
    :id "clinicaltrials"
    :source "clinicaltrials"}
   {:label "CORD19"
    :id "cord19"
    :source "cord19:*"}
   {:label "DailyMed"
    :id "dailymed"
    :source "dailymed"}
   {:label "EPAR"
    :id "epar"
    :source "epar"}
   {:label "EPAR documents"
    :id "epar-pdf"
    :source "epar-pdf"}
   {:label "WHO ICTRP"
    :id "who-ictrp"
    :source "who-ictrp:*"}
   {:label "Congresses"
    :id "doc-congress"
    :source "doc-congress:*"}
   {:label "CongressesDev"
    :id "doc-congress-dev"
    :source "doc-congress-dev:*"}
   {:label "Official"
    :id "official"
    :source "feeds:*"}
   {:label "News"
    :id "news"
    :source "feeds:*"}
   {:label "Social"
    :id "social"
    :source "feeds:*"} 
   {:label "Other"
    :id "other"
    :source "feeds:*"}])

(def category-ids (mapv :id categories))
(def category-map (index-by :id categories))
(def source-map (index-by :source categories))
